import BudgetReconciliationBillAlert from 'tio-employee/components/budget-reconciliation-bill-alert';
import { t } from 'ember-intl';
import { Header, VStack } from 'tio-ui/components/layout';
import type { TOC } from '@ember/component/template-only';

interface StrategyFinderDashboardRouteSignature {
  Blocks: {
    default: [];
  };
}

const tmpl: TOC<StrategyFinderDashboardRouteSignature> = <template>
  <VStack>
    <BudgetReconciliationBillAlert />
    <Header>{{t "common.strategy_finder.default"}}</Header>
    {{outlet}}
  </VStack>
</template>;

export default tmpl;
